import { useBreakpointValue } from "@gluestack-ui/themed";
import { MenuActionItemProps } from "@repo/core/components/layout/MenuActionsList/components/MenuActionItem/types";
import { PaymentTypeEnum } from "@repo/core/enums/payments";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";

export const InvoicePaymentOptionsController = () => {
  const { back, push } = useNavigation();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const menuActionItems: MenuActionItemProps[] = [
    {
      title: "Pagamento de fatura",
      onPress: () =>
        push(ROUTES.invoicePayment, { paymentType: PaymentTypeEnum.INVOICE })
    },
    {
      title: "Pagamento de acordo",
      onPress: () =>
        push(ROUTES.invoicePayment, { paymentType: PaymentTypeEnum.DEAL })
    }
  ];
  return { back, isMobile, menuActionItems };
};
